"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    staticClass: "product-page",
    attrs: {
      menu: _vm.menuItems.children,
      "sub-menu": _vm.menuItems.subMenu,
      "return-menu": "/farm-management/dashboard"
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("h2", {
    staticClass: "header-title"
  }, [_vm._v("\n        Produtos\n      ")]), _vm._v(" "), _c("div", {
    staticClass: "search-bar"
  }, [_c("div", {
    staticClass: "field search-input"
  }, [_c("p", {
    staticClass: "filter-label"
  }, [_vm._v("\n            Filtrar por período\n          ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("b-field", [_c("b-datepicker", {
    attrs: {
      placeholder: "Data inicial",
      icon: "calendar",
      "max-date": _vm.dateEnd,
      "mobile-native": false
    },
    on: {
      input: _vm.loadAsyncDataList
    },
    model: {
      value: _vm.dateStart,
      callback: function callback($$v) {
        _vm.dateStart = $$v;
      },
      expression: "dateStart"
    }
  })], 1), _vm._v(" "), _c("b-field", [_c("b-datepicker", {
    attrs: {
      placeholder: "Data final",
      icon: "calendar",
      "min-date": _vm.dateStart,
      "mobile-native": false
    },
    on: {
      input: _vm.loadAsyncDataList
    },
    model: {
      value: _vm.dateEnd,
      callback: function callback($$v) {
        _vm.dateEnd = $$v;
      },
      expression: "dateEnd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "field-new-item"
  }, [_c("b-button", {
    on: {
      click: function click($event) {
        return _vm.openProductModal();
      }
    }
  }, [_vm._v("\n            Novo produto\n          ")]), _vm._v(" "), _c("b-button", {
    attrs: {
      type: "is-info"
    },
    on: {
      click: function click($event) {
        return _vm.importCSV();
      }
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "upload",
      size: "is-small"
    }
  }), _vm._v(" "), _c("span", [_vm._v("Importar CSV")])], 1), _vm._v(" "), _c("input", {
    ref: "csvFileInput",
    staticStyle: {
      display: "none"
    },
    attrs: {
      type: "file",
      accept: ".csv"
    },
    on: {
      change: _vm.handleFileSelect
    }
  })], 1)])]), _vm._v(" "), _c("div", {
    staticClass: "table-items-list"
  }, [_c("b-table", {
    attrs: {
      data: _vm.list,
      loading: _vm.isLoading,
      paginated: "",
      total: _vm.total,
      "per-page": _vm.perPage,
      striped: true,
      hoverable: true,
      "backend-pagination": ""
    },
    on: {
      "page-change": _vm.onPageChange
    }
  }, [[_c("b-table-column", {
    attrs: {
      field: "nome",
      label: "Nome"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.nome) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "fornecedor",
      label: "Fornecedor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.fornecedor) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "categoria",
      label: "Categoria"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(_vm.getCategoryLabel(props.row.categoria)) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "medida",
      label: "Unidade de Medida"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.medida || "--") + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "descricao",
      label: "Descrição",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [props.row.descricao ? _c("span", {
          staticClass: "text-cell",
          attrs: {
            title: props.row.descricao
          }
        }, [_vm._v("\n              " + _vm._s(_vm.truncateText(props.row.descricao, 40)) + "\n            ")]) : _c("span", [_vm._v("--")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      width: "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-dropdown", {
          attrs: {
            "aria-role": "list",
            label: "Editar",
            position: "is-top-left"
          }
        }, [_c("b-button", {
          staticClass: "btn-click-dots",
          attrs: {
            slot: "trigger",
            outlined: "",
            "icon-right": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c("b-dropdown-item", {
          attrs: {
            "aria-role": "listitem"
          },
          on: {
            click: function click($event) {
              return _vm.openProductModal(props.row);
            }
          }
        }, [_c("b-icon", {
          attrs: {
            icon: "pencil",
            size: "is-small"
          }
        }), _vm._v("\n                Editar\n              ")], 1), _vm._v(" "), _c("b-dropdown-item", {
          attrs: {
            "aria-role": "listitem"
          },
          on: {
            click: function click($event) {
              return _vm.verifyDelete(props.row);
            }
          }
        }, [_c("b-icon", {
          attrs: {
            icon: "delete",
            size: "is-small"
          }
        }), _vm._v("\n                Excluir\n              ")], 1)], 1)];
      }
    }])
  })], _vm._v(" "), _c("template", {
    slot: "empty"
  }, [_c("section", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c("p", [_c("b-icon", {
    attrs: {
      icon: "emoticon-sad",
      size: "is-large"
    }
  })], 1), _vm._v(" "), _c("p", [_vm._v("Nenhum produto encontrado.")])])])])], 2)], 1)])], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;